import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Clearfix } from 'react-bootstrap';

import { getCurrencySymbol } from 'helpers/financial';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

class CarPrices extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['pricing'];
  }

  render() {
    const {
      intl: { messages },
      entity,
      user,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    const currencySymbol = getCurrencySymbol(entity.getPricing().getCurrency());

    return (
      <Clearfix>
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.sales_price}</p>
                  <div class="form-group-attached">
                    <FormAutocomplete
                      label={user.financial.vat_name}
                      name="vatRate"
                      value={entity.getPricing().getVatRate()}
                      meta={entity.getPricing().getVatRateMetaInformation()}
                      validation={entity.getPricing().getVatRateValidationResult()}
                      onChange={this.updateEntity}
                      options={
                        user &&
                        user.financial &&
                        user.financial.vat_rates &&
                        user.financial.vat_rates.map(vatRate => {
                          return { value: vatRate, label: vatRate + '%' };
                        })
                      }
                      complete
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.price}
                      name="price"
                      value={entity.getPricing().getPrice()}
                      meta={entity.getPricing().getPriceMetaInformation()}
                      validation={entity.getPricing().getPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.pseudo_price}
                      name="pseudoPrice"
                      value={entity.getPricing().getPseudoPrice()}
                      meta={entity.getPricing().getPseudoPriceMetaInformation()}
                      validation={entity.getPricing().getPseudoPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </Col>
            {entity.getIsResource() && (
              <Col xs={12} md={inModal ? 12 : 4}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">{messages.rent_price}</p>
                    <div class="form-group-attached">
                      <FormInput
                        prefixAddon={currencySymbol}
                        type="number"
                        label={messages.weekday_price}
                        name="weekdayPrice"
                        value={entity.getPricing().getWeekdayPrice()}
                        meta={entity.getPricing().getWeekdayPriceMetaInformation()}
                        validation={entity.getPricing().getWeekdayPriceValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        prefixAddon={currencySymbol}
                        type="number"
                        label={messages.weekend_price}
                        name="weekendPrice"
                        value={entity.getPricing().getWeekendPrice()}
                        meta={entity.getPricing().getWeekendPriceMetaInformation()}
                        validation={entity.getPricing().getWeekendPriceValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        prefixAddon={currencySymbol}
                        type="number"
                        label={messages.week_price}
                        name="weekPrice"
                        value={entity.getPricing().getWeekPrice()}
                        meta={entity.getPricing().getWeekPriceMetaInformation()}
                        validation={entity.getPricing().getWeekPriceValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        prefixAddon={currencySymbol}
                        type="number"
                        label={messages.month_price}
                        name="monthPrice"
                        value={entity.getPricing().getMonthPrice()}
                        meta={entity.getPricing().getMonthPriceMetaInformation()}
                        validation={entity.getPricing().getMonthPriceValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        )}
      </Clearfix>
    );
  }
}
CarPrices.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(CarPrices));
